import { Home, Wrench, Trees, Leaf, Droplets, Sparkles } from "lucide-react";

const u = (name, unit) => ({ name, unit });

export const SERVICE_CATEGORIES = [
  { name: "Interior", icon: Home, services: [
    u("Drywall", "per sq ft"), u("Painting", "per sq ft of floor area"), u("Flooring", "per sq ft installed"), u("Tile", "per sq ft installed"),
    u("Carpentry", "per hour"), u("Cabinets", "per linear ft"), u("Basement Renovation", "per sq ft finished"), u("Kitchen Remodel", "per sq ft of kitchen"),
    u("Bathroom Remodel", "per sq ft of bathroom"), u("Handyman", "per hour"),
  ] },
  { name: "Systems", icon: Wrench, services: [
    u("Plumbing", "per hour"), u("Electrical", "per hour"), u("HVAC", "per ton installed"), u("Water Heater", "per unit installed"), u("Insulation", "per sq ft"),
  ] },
  { name: "Exterior", icon: Trees, services: [
    u("Roofing", "per square (100 sq ft)"), u("Siding", "per sq ft"), u("Gutters", "per linear ft"), u("Windows & Doors", "per unit installed"),
    u("Decks", "per sq ft"), u("Fencing", "per linear ft"), u("Concrete & Masonry", "per sq ft"), u("Exterior Painting", "per sq ft of wall"),
  ] },
  { name: "Outdoor", icon: Leaf, services: [
    u("Landscaping", "per hour"), u("Lawn Care", "per visit"), u("Tree Service", "per crew hour"), u("Pressure Washing", "per sq ft"),
  ] },
  { name: "Restoration", icon: Droplets, services: [
    u("Water Damage", "per sq ft affected"), u("Mold Remediation", "per sq ft affected"), u("Fire Damage", "per sq ft affected"),
  ] },
  { name: "Other", icon: Sparkles, services: [
    u("Cleaning", "per hour"), u("Junk Removal", "per truckload"), u("Moving", "per crew hour"), u("Other", "per hour"),
  ] },
];

const BY_NAME = Object.fromEntries(SERVICE_CATEGORIES.flatMap((c) => c.services.map((s) => [s.name, { ...s, category: c }])));

export const isCatalogService = (name) => !!BY_NAME[name];
export const unitFor = (name) => BY_NAME[name]?.unit || "per standard job";
export const iconFor = (name) => BY_NAME[name]?.category.icon || Sparkles;
export const testIdFor = (name) => name.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");
